import { OrderStatusEnum } from "@c2b/muven-commons"

export class DashboardPendingOrderStatusModel {
    idStatus:OrderStatusEnum = OrderStatusEnum.Pending
    description:string = ""
    total:string|number = 0

    constructor(d?:Partial<DashboardPendingOrderStatusModel>) {
        Object.assign(this, d)

        this._parseStatus()
    }

    private _parseStatus():void {
        switch(this.idStatus) {
            case OrderStatusEnum.Pending:
                this.description = 'Aguardando pagamento';
                break;

            case OrderStatusEnum.Approved:
                this.description = 'Aprovado';
                break;
            
            case OrderStatusEnum.Billed:
                this.description = 'Faturado';
                break;

            case OrderStatusEnum.Posted:
                this.description = 'Postado';
                break;

            case OrderStatusEnum.Delivered:
                this.description = 'Entregue';
                break;

            case OrderStatusEnum.Canceled:
                this.description = 'Cancelado';           
                break;

            case OrderStatusEnum.Integrating:
                this.description = 'Importando';           
                break;
        }
    }
}
